import React from 'react';
import { Row, Col } from 'react-bootstrap';

const LegalDisclaimer = () => {
    return (
        <>
            <Row>
                <div style={{ padding: '1vw' }}>
                    <p>
                        This is the Data Privacy Notice of Alliance Software Inc. and its subsidiary companies.
                    </p>
                    <p style={{ marginBottom: '4rem' }}>
                        Alliance Software Inc. and its subsidiary companies shall protect and keep confidential the personal data that the subject submits, or Alliance collects from you, as required by the Data Privacy Act of 2012.
                    </p>

                    <h4><b>CONSENT TO PROCESSING</b></h4>
                    <p style={{ marginBottom: '4rem' }}>
                        By submitting this form, you consent to the collection, processing, use, sharing, storage, and disposal of the provided personal information and sensitive personal information for the purpose of Recruitment/Hiring. Your information will be handled in accordance with our Data Privacy Policy.
                    </p>

                    <h4><b>DATA COLLECTION AND SHARING</b></h4>
                    <p>
                        Alliance collects the following personal information and sensitive personal information (collectively, personal data) such as:
                    </p>
                    <ul style={{ marginBottom: '4rem' }}>
                        <li>Full name</li>
                        <li>Date of birth</li>
                        <li>Home address</li>
                        <li>Contact numbers (landline and/or mobile)</li>
                        <li>Educational Information</li>
                        <li>Employment Information</li>
                        <li>Etc.</li>
                    </ul>
                    <p>
                        Alliance collects personal data through the forms the data subject electronically accomplishes through this website. Alliance collects personal data to process as an applicant. To use your personal/sensitive personal information to verify your identity and to assess or process employment applications.
                    </p>
                    <p style={{ marginBottom: '4rem' }}>
                        Once hired, to further use the shared information to administer any company processes such as but not limited to payroll, employee benefits, performance evaluation, employee relations, and other work management and communication systems. The sharing is covered by a data sharing agreement or non-disclosure agreement and is implemented through secured means.
                    </p>

                    <h4><b>DATA PROTECTION</b></h4>
                    <p style={{ marginBottom: '4rem' }}>
                        We take reasonable steps to ensure the security of your personal information. However, please be aware that no data transmission over the internet can be guaranteed to be 100% secure. While we strive to protect your information, we cannot guarantee the security of any information you transmit to us.
                    </p>

                    <h4><b>RETENTION AND DISPOSAL</b></h4>
                    <p style={{ marginBottom: '4rem' }}>
                        Your personal data or information shall only be retained for a period necessary to serve the purpose for which it was collected, or as required by applicable law. We shall undertake to ensure that all personal data or information is disposed of in a secure manner that would prevent further processing or unauthorized access or disclosures.
                    </p>

                    <h4><b>RIGHTS OF DATA SUBJECTS</b></h4>
                    <p style={{ marginBottom: '4rem' }}>
                        You have the right to access, object, erasure or blocking, rectify, or delete your personal information. If you wish to exercise these rights or have any concerns about the processing of your data, please contact us at <a href="mailto:alliancehr@alliance.com.ph" style={{ color: '#007bff', textDecoration: 'none' }}>
                            alliancehr@alliance.com.ph
                        </a>.
                    </p>

                    <h4><b>INQUIRIES AND CONCERNS</b></h4>
                    <p >
                        For any inquiries and/or concerns about this Data Privacy Policy, please contact:
                    </p>
                    <p style={{ marginBottom: '4rem' }}>
                        <b>Data Protection Officer</b>
                        <br />
                        Alliance Software Inc.,
                        <br />
                        14F Buildcomm Center, Sumilon Road,
                        <br />
                        Cebu Business Park Cebu City 6000, Philippines
                        <br />
                        Email: <a href="mailto:dpo@alliance.com.ph" style={{ color: '#007bff', textDecoration: 'none' }}>
                            dpo@alliance.com.ph
                        </a>
                    </p>

                    <p>
                        You certify that all information provided in this form is accurate, complete, and up to date to the best of your knowledge. Any false or misleading information may result in disqualification or legal consequences.
                    </p>
                    <p>
                        By submitting this form, you acknowledge that you have read, understood, and accepted the terms and conditions outlined above, including our data privacy commitments.
                    </p>
                </div>
            </Row>
        </>
    );
};

export default LegalDisclaimer;